<template>
    <div>
        <fusioncharts
            :type="chartType"
            width="100%"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: [Array, Object],
                required: true,
            },

            donut: {
                type: Boolean,
                default: false
            },

            bgColor: {
                type: String,
                default: "#316DA0"
            },
            
            height: {
                type: [Number, String],
                default: 270
            },

            legendFontColor: {
                type: String,
                default: "#ffffff"
            },

            legendFontSize: {
                type: Number,
                default: 18
            },

            legendNumberColumns: {
                type: Number,
                default: 3
            },

            enableSmartLabels: {
                type: Boolean,
                default: true
            },

            smartLineColor: {
                type: String,
                default: "#ffffff"
            },  

            labelFontColor: {
                type: String,
                default: "#ffffff"
            },  

            showPercentValues: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                paletteColors: [
                    '22c55e',
                    '63b3ed',
                    'f6ae55',
                    '4fd1c4',
                    'f6df5e',
                    'b794f4',
                    'f687b3',
                ]
            }
        },

        computed: {
            chartType() {
                return this.donut ? 'doughnut2d' : 'pie2d';
            },

            dataSource() {
                return {
                    chart: {
                        paletteColors: this.paletteColors.join(','),
                        enableSmartLabels: this.enableSmartLabels,
                        showLabels: this.enableSmartLabels,
                        showValues: this.enableSmartLabels,
                        smartLineColor: this.smartLineColor,
                        bgColor: 'FFFFFF',
                        bgAlpha: '0',
                        canvasBgColor: 'FFFFFF',
                        canvasBgAlpha: '0',
                        showBorder: '0',
                        showCanvasBorder: '0',
                        usePlotGradientColor: '0',
                        baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
                        baseFontSize: 14,
                        caption: "",
                        showPercentValues: this.showPercentValues,
                        valueFontSize: 14,
                        labelFontColor: this.labelFontColor,
                        labelFontBold: "0",
                        plotToolText: "<b>$percentValue</b> - $label",
                        plotHighlightEffect: "fadeout",
                        use3DLighting: "1",
                        showLegend: "1",
                        legendPosition: "bottom",
                        legendItemFontSize: 13,
                        legendItemFontColor: this.legendFontColor,
                        legendNumColumns: this.legendNumberColumns,
                        legendIconScale: ".8",
                        legendItemFontBold: "0",
                        usedAtAPlotColorForLabels: "0",
                        chartLeftMargin: "20",
                        chartRightMargin: "20",
                        chartTopMargin: "10",
                        chartBottomMargin: "10",
                        containerBackgroundOpacity: "0"
                    },
                    data: this.data
                }
            }
        },
    }
</script>